import React from "react";
import Radium from "radium";
import EventListener from "react-event-listener";
import _ from "lodash";

import {
  RaisedButton,
  Checkbox,
  RadioButton,
  RadioButtonGroup,
  Toggle
} from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../../../stores/EventBucketStore";
import EventBucketActions from "../../../actions/EventBucketActions";
import LedgerActions from "../../../actions/LedgerActions";
import LedgerStore from "../../../stores/LedgerStore";
import UserStore from "../../../stores/UserStore";

import WorkingIndicator from "../working-indicator.jsx";
import Label from "../label.jsx";

import moment from "moment";
import twix from "twix";

import * as util from "../../../util";
import config from "../../../config";

class DataGridReportView extends React.Component {
  constructor(props) {
    super(props);

    this.downloadCsv = this.downloadCsv.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
  }

  static getStores() {
    return [EventBucketStore, LedgerStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getLedgerAnalyticsTransactions:
        LedgerStore.getLedgerAnalyticsTransactions,
      getLedgerTransactionReport: LedgerStore.getLedgerTransactionReport,
      isFetching: LedgerStore.getState().isFetching
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      newProps.selectedBuckets === null ||
      newProps.selectedBuckets.length === 0
    ) {
      return;
    }

    if (
      !_.isEqual(newProps.selectedBuckets, this.props.selectedBuckets) ||
      force === true
    ) {
      const conditions = this.buildConditions(newProps);

      const options = {
        timePeriod: newProps.grouping,
        includeNameAndEmail: newProps.includeNameAndEmail
      };

      if (newProps.selectedEvent) {
        // NOTE: Sending this in an array to allow for future possibility
        //       of selecting multiple events
        options.selectedEvent = [newProps.selectedEvent.id];
      }

      LedgerActions.fetchLedgerTransactionReport.defer({
        conditions,
        options
      });
    }
  }

  buildConditions(newProps) {
    let eventBuckets = newProps.selectedBuckets;
    if (typeof eventBuckets === "string") {
      eventBuckets = [eventBuckets];
    } else if (eventBuckets.length === 0) {
      eventBuckets = this.props.getEventBuckets().map(item => {
        return item.id;
      });
    }

    let conditions = Object.assign(
      {
        event_bucket: eventBuckets
      },
      !newProps.allTime && {
        date: {
          $gt: moment(newProps.startTime).startOf("day"),
          $lte: moment(newProps.endTime).endOf("day")
        }
      }
    );

    if (newProps.tType.length === 1) {
      conditions["type"] = newProps.tType[0].value;
    } else if (newProps.tType.length > 1) {
      const typeValues = newProps.tType.map(function (item) {
        return item.value;
      });
      conditions["type"] = { $in: typeValues };
    }

    if (newProps.tClass.length === 1) {
      conditions["class"] = newProps.tClass[0].value;
    } else if (newProps.tClass.length > 1) {
      const classValues = newProps.tClass.map(function (item) {
        return item.value;
      });
      conditions["class"] = { $in: classValues };
    }

    return conditions;
  }

  downloadCsv() {
    const conditions = this.buildConditions(this.props);
    let options = {
      timePeriod: this.props.grouping,
      includeNameAndEmail: this.props.includeNameAndEmail,
      format: "csv"
    };

    if (this.props.selectedEvent) {
      options.selectedEvent = [this.props.selectedEvent.id];
    }

    const form = document.createElement("form");
    form.method = "post";
    form.action = `${
      config.endpoint
    }analytics/ledger_transaction_report?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
      conditions
    )}&options=${JSON.stringify(options)}`;
    form.target = "generatedCsv";

    document.body.appendChild(form);

    window.open("", "generatedCsv");
    form.submit();
  }

  downloadPdf() {
    const conditions = this.buildConditions(this.props);
    let options = {
      timePeriod: this.props.grouping,
      includeNameAndEmail: this.props.includeNameAndEmail,
      format: "pdf"
    };

    if (this.props.selectedEvent) {
      options.selectedEvent = [this.props.selectedEvent.id];
    }

    const form = document.createElement("form");
    form.method = "post";
    form.action = `${
      config.endpoint
    }analytics/ledger_transaction_report?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
      conditions
    )}&options=${JSON.stringify(options)}`;
    form.target = "generatedPdf";

    document.body.appendChild(form);

    window.open("", "generatedPdf");
    form.submit();
  }

  getStyles() {
    return {
      overlay: {
        position: "absolute",
        right: 0,
        top: 0,
        backgroundColor: "#fff",
        boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
        zIndex: 1
      },
      overlaySubmit: {
        position: "absolute",
        right: 10,
        bottom: 10
      },
      gridHeaderRow: {
        color: "#fff",
        backgroundColor: "#0288d1"
      },
      gridHeaderLabel: {
        textAlign: "right",
        padding: "4px",
        width: "100px",
        borderRight: "1px solid #fff"
      },
      gridHeaderLabelFinancial: {
        textAlign: "right",
        padding: "4px",
        width: "75px",
        borderRight: "1px solid #fff"
      },
      gridHeaderLabelSubcategory: {
        textAlign: "right",
        padding: "4px",
        width: "75px",
        borderRight: "1px solid #fff"
      },
      gridHeaderLabelFirstColumn: {
        textAlign: "left",
        padding: "4px",
        minWidth: "150px",
        borderRight: "1px solid #fff"
      },
      gridDayTitle: {
        fontWeight: "bold",
        fontSize: "16px",
        paddingTop: "20px",
        paddingBottom: "2px",
        paddingLeft: "2px"
      },
      gridTimeTitle: {
        fontWeight: "bold",
        fontSize: "13px",
        paddingTop: "2px",
        paddingLeft: "2px",
        paddingBottom: "2px"
      },
      gridLabelCell: {
        textAlign: "left",
        padding: "2px"
      },
      gridDataCell: {
        textAlign: "right",
        padding: "2px",
        width: "100px"
      },
      gridDataCellFinancial: {
        textAlign: "right",
        padding: "2px",
        width: "75px"
      },
      gridDataCellSubcategory: {
        textAlign: "right",
        padding: "2px",
        width: "175px"
      },
      gridDataCellFirstColumn: {
        textAlign: "left",
        padding: "2px",
        minwidth: "150px"
      },
      gridDataSummaryTitle: {
        fontWeight: "bold",
        fontSize: "16px",
        padding: "2px"
      },
      gridDataOverallSummaryTitle: {
        fontWeight: "bold",
        fontSize: "20px",
        padding: "2px",
        paddingTop: "15px"
      },
      gridDataSummaryCell: {
        textAlign: "right",
        fontWeight: "bold",
        fontSize: "16px",
        padding: "2px"
      },
      gridDataOverallSummaryCell: {
        textAlign: "right",
        fontWeight: "bold",
        fontSize: "20px",
        padding: "2px",
        paddingTop: "15px"
      },
      gridButtonRow: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "start"
      }
    };
  }

  render() {
    const styles = this.getStyles();

    const {
      selectedBuckets,
      allTime,
      startDate,
      endDate,
      reportType,
      grouping,
      includeNameAndEmail
    } = this.props;

    if (!selectedBuckets || selectedBuckets.length === 0) {
      return <div>No records found.</div>;
    }

    let timePeriod = allTime
      ? "All time"
      : moment(startDate)
          .twix(endDate, { allDay: true })
          .format({ implicitYear: false });

    let displayArray = [];

    if (selectedBuckets && selectedBuckets.length > 0) {
      displayArray = this.props.getLedgerTransactionReport();
    }

    return (
      <div>
        {!this.props.isFetching ? (
          <div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                paddingTop: "20px"
              }}
            >
              <table>
                <tbody>
                  <tr style={styles.gridHeaderRow}>
                    <td style={styles.gridHeaderLabelFirstColumn}>Date</td>
                    <td style={styles.gridHeaderLabelFirstColumn}>Category</td>
                    <td style={styles.gridHeaderLabel}>Type</td>
                    <td style={styles.gridHeaderLabel}>Class</td>
                    <td style={styles.gridHeaderLabelSubcategory}>
                      Subcategory
                    </td>
                    <td style={styles.gridHeaderLabel}>Variant</td>
                    <td style={styles.gridHeaderLabel}>Acct Type</td>
                    <td style={styles.gridHeaderLabelFinancial}>Gross</td>
                    <td style={styles.gridHeaderLabelFinancial}>Fee</td>
                    <td style={styles.gridHeaderLabelFinancial}>Net</td>
                    {includeNameAndEmail ? (
                      <td style={styles.gridHeaderLabel}>Name</td>
                    ) : null}
                    {includeNameAndEmail ? (
                      <td style={styles.gridHeaderLabel}>Email</td>
                    ) : null}
                  </tr>
                  {displayArray.length > 0 ? (
                    displayArray.map(row => {
                      return (
                        <tr>
                          <td style={styles.gridDataCellFirstColumn}>
                            {row.date}
                          </td>
                          <td style={styles.gridDataCellFirstColumn}>
                            {row.event_name}
                          </td>
                          <td style={styles.gridDataCell}>{row.type}</td>
                          <td style={styles.gridDataCell}>{row.class}</td>
                          <td style={styles.gridDataCellSubcategory}>
                            {row.subcategory_label}
                          </td>
                          <td style={styles.gridDataCell}>
                            {row.variant_label}
                          </td>
                          <td style={styles.gridDataCellFinancial}>
                            {row.account_type}
                          </td>
                          <td style={styles.gridDataCellFinancial}>
                            {row.gross}
                          </td>
                          <td style={styles.gridDataCellFinancial}>
                            {row.fee}
                          </td>
                          <td style={styles.gridDataCellFinancial}>
                            {row.net}
                          </td>
                          {includeNameAndEmail ? (
                            <td style={styles.gridDataCell}>{row.name}</td>
                          ) : null}
                          {includeNameAndEmail ? (
                            <td style={styles.gridDataCell}>{row.email}</td>
                          ) : null}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">No records found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {displayArray.length > 0 ? (
              <div style={styles.gridButtonRow}>
                <div style={styles.rangeContainer}>
                  <RaisedButton
                    style={{ marginTop: "20px", marginRight: "25px" }}
                    onClick={this.downloadCsv}
                    label="DOWNLOAD (.CSV)"
                  />
                </div>
                <div style={styles.rangeContainer}>
                  <RaisedButton
                    style={{ marginTop: "20px", marginRight: "25px" }}
                    onClick={this.downloadPdf}
                    label="DOWNLOAD (.PDF)"
                  />
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <div style={{ clear: "both" }}>
            <WorkingIndicator fullPage={true} />
          </div>
        )}
      </div>
    );
  }
}

export default Radium(connectToStores(DataGridReportView));



// WEBPACK FOOTER //
// ./src/app/components/partials/report-views/data-grid-report-view.jsx